'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["size", "axis", "style"];
/**
 * Utility to fill the gaps.
 *
 * From:
 * https://www.joshwcomeau.com/react/modern-spacer-gif/
 */

var Spacer = _ref => {
  var {
    size,
    axis = '',
    style = {}
  } = _ref,
      delegated = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var width = axis === 'vertical' ? 1 : size;
  var height = axis === 'horizontal' ? 1 : size;
  return /*#__PURE__*/React__default['default'].createElement("span", _rollupPluginBabelHelpers['extends']({
    style: _rollupPluginBabelHelpers.objectSpread2({
      display: 'block',
      width,
      minWidth: width,
      height,
      minHeight: height
    }, style)
  }, delegated));
};
Spacer.propTypes = {
  size: index.number,
  axis: index.oneOf(['', 'horizontal', 'vertical']),
  style: index.object
};

exports.Spacer = Spacer;
exports.default = Spacer;
